import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { OvertimeComponent } from './overtime/overtime.component';
import { ExpertiseListPage } from './expertises/list/list.page';
import { MkReportPage } from './mk/mk-report.page';
import { PsbReportPage } from './psb/psb-report.page';
import { PsbRequestsMatchingReport } from "./psb-requests-matching/psb-requests-matching.page";
import { RetEquipReportPage } from "./retequip/retequip-report.page";
import { GeneralEquipmentReport } from './general-equipment-report/general-equipment-report.page';
import { ShelfLife1cReportPage } from './shelf-life-1c/shelf-life-1c-report.page';
import { StockExchangeRequestsReportPage } from './stock-exchange-requests/stock-exchange-requests-report.page';
import { TimeFundReportPage } from './time-fund/time-fund-report.page';
import { ExchangeSmzReportPage } from './exchange-smz/exchange-smz-report.page';
import { ExpertisePeriodReport } from './expertiseperiod/expertiseperiod.page';
import { TidObjectsTime } from './tid-objects-time/tid-objects-time.page';
import { StopReasonPage } from './stop-reason/stop-reason.page';
import { ReclamationRequestsReportPage } from './reclamation-requests/reclamation-requests-report.page';
import { LaboratoryWaterSamplesAcceptanceReportPage } from './laboratory-water-samples-acceptance/laboratory-water-samples-acceptance-report.page';
import { LaboratorySamplesAndTrialsReportPage } from './laboratory-samples-and-trials/laboratory-samples-and-trials-report.page';
import { DeferredServiceCallsReportPage } from './deferred-service-calls/deferred-service-calls-report.page';
import { RequestsWithActivitiesReportComponent } from './requests-report/requests-with-activities-report/requests-with-activities-report.component';
import { RequestsWithoutActivitiesReportComponent } from './requests-report/requests-without-activities-report/requests-without-activities-report.component';
import { RequestsReportComponent } from './requests-report/requests-report.component';
import { SmsNotificationsPeriodReportPage } from './sms-notifications-period/sms-notifications-period-report.page';
import { LeadsReportPage } from './leads-report/leads-report.page';
import { LeadsReportFormComponent } from './leads-report/leads-report-form/leads-report-form.component';

export const reportsRoutes: Routes = [
	{ path: "overtime", component: OvertimeComponent, canActivate: [AuthGuard] },
	{
		path: "expertises",
		component: ExpertiseListPage,
		canActivate: [AuthGuard],
	},
	{ path: "mk", component: MkReportPage, canActivate: [AuthGuard] },
	{ path: "sr", component: StopReasonPage, canActivate: [AuthGuard] },
	{ path: "psb", component: PsbReportPage, canActivate: [AuthGuard] },
	{ path: "reclamation-requests", component: ReclamationRequestsReportPage, canActivate: [AuthGuard] },
	{ path: "laboratory-water-samples-acceptance", component: LaboratoryWaterSamplesAcceptanceReportPage, canActivate: [AuthGuard] },
	{ path: "laboratory-samples-and-trials", component: LaboratorySamplesAndTrialsReportPage, canActivate: [AuthGuard] },
	{ path: "deferred-service-calls", component: DeferredServiceCallsReportPage, canActivate: [AuthGuard] },
	{ path: "sms-notifications-period", component: SmsNotificationsPeriodReportPage, canActivate: [AuthGuard] },
	{ path: "requests-with-activities", component: RequestsWithActivitiesReportComponent, canActivate: [AuthGuard] },
	{ path: "requests-without-activities", component: RequestsWithoutActivitiesReportComponent, canActivate: [AuthGuard] },
	{ path: "leads", component: LeadsReportPage, canActivate: [AuthGuard] },

	{
		path: "psb-requests-matching",
		component: PsbRequestsMatchingReport,
		canActivate: [AuthGuard],
	},
	{ path: 'retequip', component: RetEquipReportPage, canActivate: [AuthGuard] },
	{ path: 'general-equipment', component: GeneralEquipmentReport, canActivate: [AuthGuard] },
	{ path: 'shelflife', component: ShelfLife1cReportPage, canActivate: [AuthGuard] },
	{ path: 'stockexchangerequests', component: StockExchangeRequestsReportPage, canActivate: [AuthGuard] },
	{ path: 'timefund', component: TimeFundReportPage, canActivate: [AuthGuard] },
	{ path: 'exchangesmzrequests', component: ExchangeSmzReportPage, canActivate: [AuthGuard] },
	{ path: 'expertiseperiod', component: ExpertisePeriodReport, canActivate: [AuthGuard] },
	{ path: 'tid-objects-time', component: TidObjectsTime, canActivate: [AuthGuard] },
];

@NgModule({
	imports: [],
	exports: [RouterModule],
})
export class ReportsRoutingModule {
	public static components = [
		OvertimeComponent,
		ExpertiseListPage,
		MkReportPage,
		StopReasonPage,
		PsbReportPage,
		ReclamationRequestsReportPage,
		LaboratoryWaterSamplesAcceptanceReportPage,
		PsbRequestsMatchingReport,
		RetEquipReportPage,
		GeneralEquipmentReport,
		ShelfLife1cReportPage,
		StockExchangeRequestsReportPage,
		TimeFundReportPage,
		ExchangeSmzReportPage,
		ExpertisePeriodReport,
		TidObjectsTime,
		LaboratorySamplesAndTrialsReportPage,
		DeferredServiceCallsReportPage,
		SmsNotificationsPeriodReportPage,
		RequestsReportComponent,
		RequestsWithActivitiesReportComponent,
		RequestsWithoutActivitiesReportComponent,
		LeadsReportPage,
		LeadsReportFormComponent,
	];
}
